const RANDOM_WORDS = [
  'ocean', 'sunrise', 'forest', 'river', 'mountain', 'breeze', 'valley', 'meadow',
  'comet', 'nebula', 'galaxy', 'orbit', 'horizon', 'zenith', 'aurora', 'coral',
  'crystal', 'diamond', 'emerald', 'sapphire', 'topaz', 'opal', 'ruby', 'jade',
  'moon', 'star', 'planet', 'cloud', 'storm', 'spring', 'summer', 'autumn', 'winter',
  'wind', 'rain', 'snow', 'frost', 'flame', 'spark', 'ember', 'glacier', 'tundra',
  'canyon', 'desert', 'oasis', 'lagoon', 'reef', 'tide', 'wave', 'surge',
  'thunder', 'lightning', 'echo', 'shadow', 'light', 'beam', 'ray', 'flare',
  'nova', 'pulsar', 'quasar', 'cosmos', 'infinity', 'void', 'abyss', 'chasm',
  'peak', 'summit', 'crest', 'ridge', 'cliff', 'crag', 'plateau', 'mesa',
  'grove', 'thicket', 'jungle', 'canopy', 'timber', 'woodland', 'marsh', 'swamp',
  'bog', 'fen', 'moor', 'heath', 'savanna', 'prairie', 'steppe', 'pampas',
  'boulder', 'pebble', 'stone', 'rock', 'mineral', 'ore', 'quartz', 'flint',
  'obsidian', 'onyx', 'agate', 'jasper', 'garnet', 'amethyst', 'beryl', 'zircon',
  'pearl', 'amber', 'ivory', 'bone', 'horn', 'shell', 'scale', 'feather',
  'wing', 'tail', 'claw', 'fang', 'talon', 'beak', 'snout', 'hoof',
  'mane', 'pelt', 'fur', 'hide', 'fleece', 'wool', 'silk', 'velvet'
];

export const RESERVED_SUBDOMAINS = new Set([
  'admin', 'api', 'app', 'billing', 'root', 'gateway', 'auth', 'login', 'mail',
  'dashboard', 'dev', 'staging', 'prod', 'test', 'status', 'superadmin', 'super-admin'
]);

export function generateRandomSuffix() {
  const word = RANDOM_WORDS[Math.floor(Math.random() * RANDOM_WORDS.length)];
  return word;
}

export function validateSubdomainPrefix(val) {
  if (!val || !val.trim()) {
    return { valid: true, error: '' }; // optional, will fallback to appName
  }
  const clean = val.trim().toLowerCase();
  if (/\s/.test(clean)) {
    return { valid: false, error: 'Spaces are not allowed. Use hyphens (-) instead.' };
  }
  if (/\./.test(clean)) {
    return { valid: false, error: 'Dots (.) are not allowed in subdomains.' };
  }
  if (/[A-Z]/.test(val)) {
    return { valid: false, error: 'Uppercase letters are not allowed. Use lowercase only.' };
  }
  if (!/^[a-z0-9-]+$/.test(clean)) {
    return { valid: false, error: 'Only lowercase letters, numbers, and hyphens (-) are allowed.' };
  }
  if (clean.startsWith('-') || clean.endsWith('-')) {
    return { valid: false, error: 'Subdomain cannot start or end with a hyphen.' };
  }
  if (clean.length < 2 || clean.length > 40) {
    return { valid: false, error: 'Subdomain must be between 2 and 40 characters.' };
  }
  if (RESERVED_SUBDOMAINS.has(clean)) {
    return { valid: false, error: `"${clean}" is a reserved system name and cannot be used.` };
  }
  return { valid: true, error: '' };
}
